import CompanyModulesApi from '@/api/company-modules.js'
import AdminCompanyModulesApi from '@/api/admin-company-modules.js'
import GlobalModulesApi from '@/api/global-modules.js'

function prepareCompanyModules(params) {
  const isArray = Boolean(Array.isArray(params)) && params.length;
  return isArray ? params.map(item => {
    item.is_requested = false;
    return item
  }) : []
}

function getStore(Api) {
  return {
    namespaced: true,

    state() {
      return {
        modules: []
      }
    },

    mutations: {
      saveModules: (state, v) => {
        state.modules = v;
      },
      // избавиться от мутации вложенного объекта пришедшего сверху.
      changeModuleValue: (state, v) => {
        v.module[v.key] = v.value
      },

      setRequestedStatus: (state, v) => {
        v.is_requested = true
      }
    },

    actions: {
      async fetch({ dispatch }, payload) {
        return Api.fetchModules(payload).then(v => {
          dispatch('saveModules', prepareCompanyModules(v));
        });
      },

      async updateModule({ dispatch }, params) {
        await dispatch('changeModuleValue', params)

        const updatedModule = await Api.updateModule(params.body)

        await dispatch('saveModule', updatedModule);
      },

      async changeModuleValue({ commit, state }, params) {
        const moduleItem = state.modules.find(item => item.id === params.id);
        commit('changeModuleValue', {
          module: moduleItem,
          value: params.value,
          key: params.key
        });
      },

      async requestModulePayment({ dispatch }, params) {
        await dispatch('changeRequestStatus', params)
        const updatedModule = await Api.requestModulePayment(params)
        await dispatch('saveModule', updatedModule);
      },

      changeRequestStatus({ commit, state }, params) {
        const moduleItem = state.modules.find(item => item.id === params.id);
        if (moduleItem) {
          commit('setRequestedStatus', moduleItem)
        }
      },

      saveModules: (context, v) => {
        context.commit('saveModules', prepareCompanyModules(v));
      },

      saveModule: ({ commit, state }, v) => {
        if (v[0]) {
          const data = state.modules.map(item => {
            if (item.id === v[0].id) {
              item = v[0]
            }
            return item
          })
          commit('saveModules', prepareCompanyModules(data));
        }
      }
    },

    getters: {
      getModules: state => state.modules
    }
  }
}

export const adminCompanyModules = getStore(AdminCompanyModulesApi);
export const globalModules = getStore(GlobalModulesApi);
export const companyModules = getStore(CompanyModulesApi);
